import React from 'react'
import {DocsMain} from './DocsMain'
import {DraftsTable} from './Drafts'

const DraftAndSentReq = () => {
  return (
    <>
      <div className='d-flex flex-wrap flex-stack'>
        <div className='d-flex'>
          <h1 className='mb-4 mb-lg-0 fs-3 fw-semibold'>Manage Requests</h1>
        </div>
        {/* <div className='d-flex'>
          <div className='m-auto d-flex align-items-center'>
            <button className='btn btn-sm btn-light fw-normal' onClick={() => {}}>
              <i className='ki-duotone ki-information-2 fs-3'>
                <span className='path1'></span>
                <span className='path2'></span>
                <span className='path3'></span>
              </i>
              Know More
            </button>
          </div>
        </div> */}
      </div>
      <p className='d-none d-lg-block fs-6 text-gray-600 mb-4'>
        Create, view, and manage all your signature requests in one place. Track draft requests you
        are preparing, as well as requests already sent to recipients for signing. Stay organized
        and monitor progress to ensure every document is completed on time.
      </p>
      <div className='row g-6'>
        <div className='col-12 col-lg-4'>
          <DraftsTable />
        </div>
        <div className='col-12 col-lg-8'>
          <DocsMain />
        </div>
      </div>
    </>
  )
}

export {DraftAndSentReq}
